<tec-item
    [classes]="['item--outline']"
    [outline]="true"
    [tagImage]="{ icon: 'icon-shield', status: 'simple' }"
    [tagIcon]="tagIcon"
    [title]="'PROCESSES.DETAIL.FRAUD_FACE_BLOCK' | translate"
    [clickeable]="false"
>
    <tec-list-detail>
        <span>{{
            (!locks?.blocked_faces?.length
                ? 'PROCESSES.DETAIL.FRAUD_FACE_BLOCK_RESULT_OK'
                : 'PROCESSES.DETAIL.FRAUD_FACE_BLOCK_RESULT_KO'
            ) | translate
        }}</span>
    </tec-list-detail>
</tec-item>
